import type { ActionError } from "@/types";

export type ClientOperationError = Error & { code: ActionError };

export const createActionError = (
  code: ActionError,
): ClientOperationError => {
  const error = new Error("Client operation failed") as ClientOperationError;
  error.name = "ClientOperationError";
  error.code = code;
  return error;
};

export const createAbortAwareActionError = (
  code: ActionError,
): ClientOperationError => {
  const error = createActionError(code);
  if (code === "cancelled") error.name = "AbortError";
  return error;
};

export const getActionErrorCode = (
  error: unknown,
): ActionError | undefined => {
  if (!error || typeof error !== "object") return undefined;
  const code = (error as { code?: unknown }).code;
  return typeof code === "string" ? (code as ActionError) : undefined;
};

export const getUserErrorMessage = (
  error: unknown,
  messages: {
    generic: string;
    networkUnavailable?: string;
    timeout?: string;
    unauthorized?: string;
    unsupportedFile?: string;
  },
): string | undefined => {
  switch (getActionErrorCode(error)) {
    case "cancelled":
    case "purchaseCancelled":
      return undefined;
    case "networkUnavailable":
      return messages.networkUnavailable || messages.generic;
    case "timeout":
      return messages.timeout || messages.generic;
    case "unauthorized":
      return messages.unauthorized || messages.generic;
    case "UnsupportedFile":
      return messages.unsupportedFile || messages.generic;
    default:
      return messages.generic;
  }
};
